module.exports = __webpack_public_path__ + "img/ZB52_06.c751c4e8.jpg";